
<div (change)="change($event)"
    [(ngModel)]="color"
    [hideTextInput]="true"
    class="colorPicker"
    ngx-colors-trigger
    [disabled]="disabled"
    >
    <div class="colorPicker-shape"
              [style.background]="color"
              >
    </div>
    <div  class="colorPicker-label body-l-regular text-extra">	{{ 'MODALS.FIELDS.COLOR' | translate }}	 </div>
</div>
<!-- <div (change)="change($event)"
     [(ngModel)]="color"
     [hideTextInput]="true"
     [style.background]="color"
     class="colorPicker"
     ngx-colors-trigger
>
    <h2 [ngbTooltip]="name"
        style="margin-top: 7px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;"
    >
        {{ name }}
    </h2>
</div>
 -->